module.exports = __webpack_public_path__ + "img/step3.d819a4d6.png";